import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card, message, Divider, Select, Typography, Space, Progress } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
import { maskMoney, parseToInt } from "../../../helpers/masks";
const { Text } = Typography;

const array_status_filtro = [
  { label: "Todos", value: 999 },
  { label: "Participação confirmada", value: 1 },
  { label: "Pendente", value: 2 }
];

const statusConfig = {
  1: { label: "Participação confirmada", type: "success" },
  2: { label: "Pendente", type: "warning" },
};

export const CampanhasVacinacaoColaboradores = ({ to }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const id_cad_filiais = !!searchParams.get("id_cad_filiais")
    ? searchParams.get("id_cad_filiais")
    : 999;
  const status = !!searchParams.get("status") ? searchParams.get("status") : 999;
  const navigate = useNavigate();
  const { id_campanha } = useParams();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [campanha, setCampanha] = useState({});
  const [campanhaFiliais, setCampanhaFiliais] = useState([]);

  useEffect(() => {
    const carregarDados = async () => {
      if (!id_campanha) return;

      listarCampanhaFiliais(id_campanha);
      const dadosCampanha = await carregarCampanha(id_campanha);
      setCampanha(dadosCampanha ?? {});
      listarColaboradores(id_campanha);
    };

    carregarDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id_campanha]);

  //CARREGAR CAMPANHA
  const carregarCampanha = async (id) => {
    if (!id) return null;
    setLoading(true);
    const api = await http("get", `v1/campanhas_vacinacao/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setLoading(false);
      return api?.response?.data;
    } else {
      navigate(to);
      message.error(api.response.message);
      setLoading(false);
      return null;
    }
  };

  // LISTAR FILIAIS DA CAMPANHA
  const listarCampanhaFiliais = async (id) => {
    const api = await http("get", `v1/campanhas_vacinacao_filiais/listar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data?.data;
      let array = [];
      if (!!response) {
        for (let e of response) {
          array.push({
            value: e.key,
            label: e.title,
          });
        }
      }
      setCampanhaFiliais(array);
    } else {
      message.error(api.response.message);
    }
  };

  // LISTAR
  const listarColaboradores = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/campanhas_vacinacao_lancamento/listar/${id}`, []);

    if (api.statusCode === 200) {
      dispatch({ type: "LOAD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Colaborador",
      dataIndex: "colaborador",
    },
    {
      title: "Filial",
      dataIndex: "filial",
    },
    {
      title: "Situação",
      dataIndex: "status",
      width: 200,
      render: (_, e) => {
        const cfg = statusConfig[e?.status];
        return cfg ? <Text type={cfg.type}>{cfg.label}</Text> : "-";
      },
      renderText: (e) => statusConfig[e?.status]?.label ?? "-",
    },
  ];

  const filteredData = React.useMemo(
    () => handleFilter(dados, parseToInt(id_cad_filiais), parseToInt(status)),
    [dados, id_cad_filiais, status]
  );

  const total_realizados = dados?.filter((e) => e?.status === 1);

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Campanhas de Vacinação" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title={["Campanha de Vacinação", "Colaboradores"]}
              subtitle={campanha?.titulo_campanha ?? ""}
              icon={<UserOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Progress
                type="line"
                size="small"
                format={(percent) => maskMoney(percent, 2) + "%"}
                percent={dados?.length > 0 ? (total_realizados?.length / dados?.length) * 100 : 0}
              />
              <TableCustom
                rowKey="key"
                extraHeaderComponents={
                  <>
                    <Space direction="vertical" size={0}>
                      <Text style={{ fontSize: 12 }} type="secondary">
                        Filial:
                      </Text>
                      <Select
                        placeholder="Selecione a filial"
                        style={{ minWidth: 200 }}
                        value={parseToInt(id_cad_filiais)}
                        disabled={loading}
                        options={[{ value: 999, label: "Todos" }, ...campanhaFiliais]}
                        onChange={(val) =>
                          setSearchParams((state) => {
                            state.set("id_cad_filiais", val);
                            return state;
                          })
                        }
                      />
                    </Space>
                    <Space direction="vertical" size={0}>
                      <Text style={{ fontSize: 12 }} type="secondary">
                        Situação:
                      </Text>
                      <Select
                        placeholder="Selecione uma opção"
                        style={{ minWidth: 200 }}
                        value={parseToInt(status)}
                        disabled={loading}
                        options={array_status_filtro}
                        onChange={(val) =>
                          setSearchParams((state) => {
                            state.set("status", val);
                            return state;
                          })
                        }
                      />
                    </Space>
                  </>
                }
                loading={loading}
                columns={columns}
                dataSource={filteredData}
                expandable={{
                  expandedRowRender: (record) => {
                    const dependentes = record.dependentes || [];

                    if (dependentes.length === 0) {
                      return (
                        <Text type="secondary" style={{ paddingLeft: 16 }}>
                          Nenhum dependente vinculado a este lançamento.
                        </Text>
                      );
                    }

                    return (
                      <div style={{ margin: "8px 0" }}>
                        <Text strong style={{ marginBottom: 8, display: "block" }}>
                          Dependentes vinculados:
                        </Text>
                        <TableCustom
                          size="small"
                          showPagination={false}
                          showLinkCsv={false}
                          showSearch={false}
                          dataSource={dependentes}
                          rowKey="id"
                          columns={[
                            {
                              title: "Nome do Dependente",
                              dataIndex: "nome",
                              key: "nome",
                            },
                            {
                              title: "CPF",
                              dataIndex: "cpf",
                              key: "cpf",
                              render: (cpf) => cpf || "-",
                            },
                            {
                              title: "Idade",
                              dataIndex: "idade",
                              key: "idade",
                              render: (idade) => (idade ? `${idade} anos` : "-"),
                            },
                          ]}
                        />
                      </div>
                    );
                  },
                  rowExpandable: (record) => true,
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};

const handleFilter = (data, id_cad_filiais, status) => {
  if (data?.length === 0) {
    return [];
  }

  let filteredData = data;
  if (id_cad_filiais !== 999) {
    filteredData = filteredData?.filter((e) => e?.id_cad_filiais === id_cad_filiais);
  }

  if (status !== 999) {
    filteredData = filteredData?.filter((e) => e?.status === status);
  }

  return filteredData;
};
